import five from "../../../src/assets/images/five.png";
import four from "../../../src/assets/images/four.png";
import three from "../../../src/assets/images/three.png";
import two from "../../../src/assets/images/two.png";
import one from "../../../src/assets/images/one.png";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import { Tooltip, IconButton } from "@mui/material";

import SentimentBar from "./SentimentBar";
import classes from "./SentimentItem.module.css";
import { trimBeforeInstructions } from "./SentimentTable";

function SentimentItem({ 
  sentiment, 
  selectedInput, 
  onQuestionInfoClick, 
  onExplanationInfoClick,
  showInfoIcons = false 
}) {
  const selectedSentiment = sentiment;
  let sentimentIcon = "";
  
  switch (selectedSentiment?.llm_sentiment) {
    case "Positive":
    case "Highly Likely":
      sentimentIcon = <img height={30} width={30} src={five} alt="5" />;
      break;
    case "Slightly Positive":
    case "Likely":
      sentimentIcon = <img height={30} width={30} src={four} alt="4" />;
      break;
    case "Neutral":
      sentimentIcon = <img height={30} width={30} src={three} alt="3" />;
      break;
    case "Unlikely":
    case "Slightly Negative":
      sentimentIcon = <img height={30} width={30} src={two} alt="2" />;
      break;
    case "Very Unlikely":
    case "Negative":
      sentimentIcon = <img height={30} width={30} src={one} alt="1" />;
      break;
    default:
      sentimentIcon = "";
  }

  const isReporting = window.location.search.includes('isReporting=true');

  let displaySources = selectedSentiment?.sources && isReporting
    ? selectedSentiment.sources.slice(0, 5)
    : selectedSentiment?.sources;

  displaySources =
    displaySources?.filter((source) => !source.includes("vertexaisearch")) || [];

  return (
    <div className={classes.container}>
      <div>
        {!selectedSentiment?.confidenceScores && (
          <div className="d-flex flex-column my-3">
            <span className={classes.sentiment_text}>
              {selectedSentiment?.llm_sentiment}
            </span>
            <div className="d-flex align-items-center">
              {sentimentIcon && (
                <span className={classes.sentiment_icon}>{sentimentIcon}</span>
              )}
              <span className={classes.sentiment_score}>
                {selectedSentiment?.sentiment !== undefined ||
                  selectedSentiment?.sentiment != null
                  ? `Sentiment: ${selectedSentiment?.sentiment}`
                  : selectedSentiment?.llm_sentiment_score}
              </span>
            </div>
          </div>
        )}
        {selectedSentiment?.confidenceScores &&
          selectedSentiment?.llm_sentiment && (
            <SentimentBar
              confidenceScores={selectedSentiment?.confidenceScores}
              sentiment={selectedSentiment?.llm_sentiment}
            />
          )}
        {selectedSentiment?.question && (
          <div style={{ display: 'flex', alignItems: 'flex-start', gap: '8px', marginBottom: '8px' }}>
            <b className="d-block" style={{marginTop:'2px'}}>
              {trimBeforeInstructions(selectedSentiment?.question)}
            </b>
            {showInfoIcons && onQuestionInfoClick && (
              <Tooltip title="View Question Base Prompt" arrow>
                <IconButton
                  size="small"
                  onClick={() => onQuestionInfoClick(selectedSentiment?.question)}
                  sx={{
                    padding: '4px',
                    '&:hover': {
                      backgroundColor: 'primary.light',
                      color: 'primary.main'
                    }
                  }}
                >
                  <InfoOutlinedIcon fontSize="small" />
                </IconButton>
              </Tooltip>
            )}
          </div>
        )}
        <p className={classes.response_text}>{selectedSentiment.response}</p>

        {selectedSentiment?.explanation && (
          <div>
            <div style={{ display: 'flex', alignItems: 'center', gap: '8px', marginBottom: '8px' }}>
              <b>Explanation:</b>
              {showInfoIcons && onExplanationInfoClick && (
                <Tooltip title="View Sentiment Analysis Base Prompt" arrow>
                  <IconButton
                    size="small"
                    onClick={onExplanationInfoClick}
                    sx={{
                      padding: '4px',
                      '&:hover': {
                        backgroundColor: 'primary.light',
                        color: 'primary.main'
                      }
                    }}
                  >
                    <InfoOutlinedIcon fontSize="small" />
                  </IconButton>
                </Tooltip>
              )}
            </div>
            <span className={classes.response_text}>
              {selectedSentiment?.explanation}
            </span>
          </div>
        )}
        <hr />
        {displaySources && displaySources.length > 0 && selectedInput?.llm?.toLowerCase().includes("search") && (
          <div>
            <b>Data Sources</b>
            <br />
            <ul>
              {displaySources?.map((url, idx) => {
                return (
                  <li key={idx}>
                    <a href={url} target="_blank" rel="noopener noreferrer">
                      {url}
                    </a>
                  </li>
                );
              })}
            </ul>
            <hr />
          </div>
        )}
      </div>
    </div>
  );
}

export default SentimentItem;